import axios from '../../axios/index';

export default {
    getFiltersInformation () {
        return axios.get('/api/v1/factory-tests/filters');
    },
    getFactoryTestReportList (httpOptions) {
        return axios.get('/api/v1/factory-tests', httpOptions);
    },

    getCreationInformation () {
        return axios.get('/api/v1/factory-tests/info');
    },

    createUpdateFactoryTestReport (data) {
        let formData = new FormData();

        if (Object.keys(data).length !== 0 && data.constructor === Object) {
            Object.keys(data).forEach(function (key) {
                if (data[key] !== null && typeof data[key].id !== 'undefined') {
                    formData.append(key + '_id', data[key].id);
                } else {
                    if (data[key] !== null && Array.isArray(data[key]) && data[key].length) {
                        for (let i = 0; i < data[key].length; i++) {

                            if (typeof data[key][i].file !== 'undefined') {
                                formData.append(key + '[' + i + ']', data[key][i].file);
                            } else {
                                switch (data[key][i].data_type) {
                                    case 'Models\\FactoryTests\\FactoryTestReportReference':
                                        formData.append(key + '[' + i + ']', JSON.stringify({
                                            id: data[key][i].id,
                                            value: data[key][i].value,
                                            name: data[key][i].name,
                                        }));
                                        break;
                                    case 'Models\\TestingSubject':
                                        formData.append(key + '[' + i + ']', JSON.stringify({
                                            id: data[key][i].id,
                                            name: data[key][i].name,
                                        }));
                                        break;
                                    case 'Models\\FactoryTests\\FactoryTestReportTests':
                                        let test = JSON.parse(JSON.stringify(data[key][i]));

                                        if (test.test_images.length) {
                                            for (let j = 0; j < test.test_images.length; j++) {
                                                test.test_images[j] = test.test_images[j].file;
                                            }
                                        }

                                        formData.append(key + '[' + i + ']', JSON.stringify(test));

                                        break;
                                    case 'Models\\FactoryTests\\FactoryTestReportTestV2':
                                        let testV2 = JSON.parse(JSON.stringify(data[key][i]));

                                        if (testV2.assignee) {
                                            testV2.assignee_id = testV2.assignee.id;
                                        }
                                        delete(testV2.assignee);
                                        if (testV2.test_images.length) {
                                            for (let j = 0; j < testV2.test_images.length; j++) {
                                                testV2.test_images[j] = testV2.test_images[j].file;
                                            }
                                        }
                                        if (testV2.attachments.length) {
                                            for (let j = 0; j < testV2.attachments.length; j++) {
                                                testV2.attachments[j] = testV2.attachments[j].file;
                                            }
                                        }
                                        if (testV2.testings && testV2.testings.length) {
                                            for (let j = 0; j < testV2.testings.length; j++) {
                                                testV2.testings[j] = JSON.stringify({
                                                    id: testV2.testings[j].id,
                                                    value: true,
                                                });
                                            }
                                        }

                                        formData.append(key + '[' + i + ']', JSON.stringify(testV2));

                                        break;
                                    default:
                                        formData.append(key + '[' + i + ']', data[key][i]);

                                        break;
                                }
                            }
                        }
                    } else {
                        if (data[key] !== null && Array.isArray(data[key])) {
                            // A workaround for sending empty arrays
                            formData.append(key + '[]', null);
                        } else {
                            formData.append(key, data[key]);
                        }
                    }
                }
            });
        }

        if (!data.id) {
            return axios.post('/api/v1/factory-tests/create', formData);
        }

        return axios.post('/api/v1/factory-tests/' + data.id, formData);
    },

    getFactoryTestReport (id) {
        return axios.get('/api/v1/factory-tests/' + id);
    },

    cancelFactoryTestReport (id, reason) {
        return axios.post('/api/v1/factory-tests/cancel/' + id, { canceled_reason: reason });
    },

    completeFactoryTestReport (id) {
        return axios.post('/api/v1/factory-tests/complete/' + id);
    },

    approveRejectFactoryTestReport (id, isApproved, reason) {
        let data = new FormData();
        data.append('is_approved', isApproved);
        data.append('reason', reason);

        return axios.post('/api/v1/factory-tests/approve-reject/' + id, data);
    },

    getFileUploadUrl (fileName) {
        return axios.get('/api/v1/factory-tests/file-upload-url', {
            params: {
                file_name: fileName,
            },
        });
    },
    getOpenPdfUrl (id) {
        return axios.post(
            '/api/v1/factory-tests/get-signed-url-for-pdf-download/' + id);
    },
};
